import React, {Fragment, useRef, useState} from 'react';
import {useTheme} from "@material-ui/core";
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {Popup, Text} from '../../';
import {Form, Field} from 'react-final-form';
import {connect} from 'react-redux';

function CRUD_popup(props){
    let folder=undefined;
    if(props.folders!=undefined && props.folders[props.folder_type]!=undefined){
      folder=props.folders[props.folder_type][props.id];
    }
    console.log(folder, props, 'FOLDER AND PROPS');
    function onSubmit(params){
      params.type=props.folder_type;
      params.folder_id=props.folder_id;
      if(props.id==undefined){props.createFolder(params);}
      else{props.updateFolder(props.id, params);}
      props.handleClose();
    }
    return(<Form
      initialValues={(folder==undefined)?undefined:{name:folder.name, description:folder.description}}
      onSubmit={onSubmit}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
          <Popup always_open accept_button={(props.delete==true)?'Delete':'Save'} accept_button_click={()=>{if(props.delete==true){props.deleteFolder(props.id);}else{form_props.form.submit(); form_props.form.reset();}}} handleClose={props.handleClose} title={(props.delete==true)?'Delete folder':(props.id==undefined)?'New folder':'Edit folder'} content={
            <div>
              {(props.delete==true)?
                <div style={{width:'calc(100% - 40px)', height:'100px', marginLeft:'20px', marginTop:'30px', marginBottom:'30px'}}><Typography>Are you sure you want to delete this folder? It's contents will not be deleted. They will shift to the parent folder.</Typography></div>
              :
              <Grid container style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'20px', marginBottom:'20px'}}>
                <Grid item xs={12}><Text title='Name' name='name'/></Grid>
                <Grid item xs={12}><Text title='Description' name='description' multiline rows={4}/></Grid>
              </Grid>
            }
           </div>

        }/>
      </form>
    )}
  </Form>
    )
}



export default connect(ss, dd)(CRUD_popup);


function ss(state){
  return{
    folders:state.folders.data,
    folders_refresh:state.folders.refresh
  }
}

function dd(dispatch){
  return{
    deleteFolder:(id)=>{dispatch({type:'REQUEST_FOLDER_DELETE', id:id})},
    createFolder:(payload)=>{dispatch({type:'REQUEST_FOLDER_CREATE', payload:payload})},
    updateFolder:(id, data)=>{dispatch({type:'REQUEST_FOLDER_UPDATE', id:id, payload:data})},
  }
}
